import NextImage, { ImageProps } from 'next/image';

type Loader = {
  src: string;
};

function loader({ src }: Loader) {
  return src;
}

export const Image = (props: ImageProps) => (
  <NextImage loader={loader} {...props}  unoptimized/>
);
